@for (
  buildingBlock of buildingBlocks();
  track trackBlock($index, buildingBlock);
  let first = $first;
  let last = $last
) {
  <span>
    @switch (buildingBlock.collection) {
      @case ('ampersandAndText') {
        <ss-www-ampersand-and-text
          [ampersandAndTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-ampersand-and-text>
      }
      @case ('carousels') {
        <ss-www-carousel
          [carouselData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-carousel>
      }
      @case ('faqs') {
        <ss-www-faqs
          [faqData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-faqs>
      }
      @case ('floatingTiles') {
        <ss-www-floating-tiles
          [floatingTileData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-floating-tiles>
      }
      @case ('heroImage') {
        <ss-www-hero-media
          [heroImageData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [priority]="first"
          [lastBlock]="last"
        ></ss-www-hero-media>
      }
      @case ('heroVideo') {
        <ss-www-hero-media
          [heroVideoData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-hero-media>
      }
      @case ('infoModals') {
        <ss-www-info-modal
          [modalData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
        ></ss-www-info-modal>
      }
      @case ('jotformBlock') {
        <ss-www-jotform-block
          [jotformBlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-jotform-block>
      }
      @case ('jumpToSections') {
        <ss-www-jump-to-section
          [jumpToSection]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-jump-to-section>
      }
      @case ('largeItemCards') {
        <ss-www-large-item-cards
          [largeItemCardsData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-large-item-cards>
      }
      @case ('promoBlock') {
        <ss-www-promo-block
          [promoBlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-promo-block>
      }
      @case ('promoModals') {
        <ss-www-promo-modal
          [modalData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
        ></ss-www-promo-modal>
      }
      @case ('starDivider') {
        <ss-www-star-divider
          [starDividerData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-star-divider>
      }
      @case ('showCTABlock') {
        <ss-www-show-cta-block
          [showCTABlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-show-cta-block>
      }
      @case ('imageTiles') {
        <ss-www-image-tiles
          [imageTileData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-image-tiles>
      }
      @case ('sideBySideImageText') {
        <ss-www-side-by-side-image-text
          [sideBySideImageTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-side-by-side-image-text>
      }
      @case ('textCTA') {
        <ss-www-text-cta
          [textCTAData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-text-cta>
      }
      @case ('textBlock') {
        <ss-www-text-block
          [textBlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-text-block>
      }
      @case ('nowPlaying') {
        <ss-www-now-playing
          [nowPlayingData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-now-playing>
      }
      @case ('infoCarousel') {
        <ss-www-info-carousel
          [infoCarouselData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-info-carousel>
      }
      @case ('filmSelector') {
        <ss-www-film-selector
          [filmSelectorData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-film-selector>
      }
      @case ('timeline') {
        <ss-www-timeline
          [timelineData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-timeline>
      }
      @case ('smallCards') {
        <ss-www-small-cards
          [smallCardsData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-small-cards>
      }
      @case ('sideBySideCarouselAndText') {
        <ss-www-side-by-side-carousel-text
          [sideBySideCarouselAndTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-side-by-side-carousel-text>
      }
      @case ('textByTextCard') {
        <ss-www-text-by-text-card
          [textByTextCardData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-text-by-text-card>
      }
      @case ('sideBySideCarouselDynamicText') {
        <ss-www-side-by-side-carousel-dynamic-text
          [sideBySideCarouselAndDynamicTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-side-by-side-carousel-dynamic-text>
      }
      @case ('promoStayInTouchForm') {
        <ss-www-promo-stay-in-touch-form
          [promoStayInTouchFormData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-promo-stay-in-touch-form>
      }
      @case ('showDetails') {
        <ss-www-show-details
          [showDetailsData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-show-details>
      }
      @case ('duoSelector') {
        <ss-www-duo-selector
          [duoSelectorData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        >
        </ss-www-duo-selector>
      }
      @case ('mobileCTA') {
        <ss-www-mobile-cta
          class="fixed z-50 bottom-0 left-0 w-full md:hidden"
          [mobileCTAData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-mobile-cta>
      }
      @case ('donationRequestForm') {
        <ss-www-donation-request-form
          [donationRequestFormData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-donation-request-form>
      }
      @case ('mediaToolkitAssetsShow') {
        <ss-www-toolkit-asset-list-block
          [assetListContent]="buildingBlock.item!"
          [collectionName]="buildingBlock.collection"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
        ></ss-www-toolkit-asset-list-block>
      }
      @case ('resellerToolkitAssetsShow') {
        <ss-www-toolkit-asset-list-block
          [assetListContent]="buildingBlock.item!"
          [collectionName]="buildingBlock.collection"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
        ></ss-www-toolkit-asset-list-block>
      }
    }
  </span>
}
@if (isServerSide) {
  <ss-www-question-answer-schema [buildingBlocks]="page()!.buildingBlocks" />
}
